import { IAccMonKhongTinhHocPhi } from "../../../model/respone/category/IAccMonKhongTinhHocPhi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAccMonKhongTinhHocPhiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IAccMonKhongTinhHocPhi[],
  LOAD_ERRR: "",

  SAVE_START: {} as IAccMonKhongTinhHocPhi,
  SAVE_SUCCESS: {} as IAccMonKhongTinhHocPhi,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IAccMonKhongTinhHocPhi,
  CLOSE_EDIT_MODAL: undefined,
};
export const eAccMonKhongTinhHocPhiActionIds = generateActionTypeIds(
  eAccMonKhongTinhHocPhiActionsObj,
  "MON_KHONG_TINH_HOC_PHI",
);

export type IAccMonKhongTinhHocPhiActionTypes = IGenericActionType<
  typeof eAccMonKhongTinhHocPhiActionsObj,
  "MON_KHONG_TINH_HOC_PHI"
>;
